import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3065ce76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs tw-bg-[#ffffff] tw-w-full" }
const _hoisted_2 = { class: "tw-flex tw-flex-wrap tw-justify-between tw-border-b-[#EFF0F1] tw-border-solid tw-border-[0] tw-border-b-[1px] tw-pr-[20px]" }
const _hoisted_3 = { class: "tab-header tw-flex tw-flex-wrap" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "tw-flex tw-flex-row tw-gap-[10px] tw-items-center tw-justify-center" }
const _hoisted_6 = { class: "title tw-flex tw-flex-row" }
const _hoisted_7 = { class: "value" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-px-2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "4",
    height: "11",
    viewBox: "0 0 4 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      x: "3.03418",
      y: "0.541016",
      width: "1",
      height: "10",
      rx: "0.5",
      transform: "rotate(15 3.03418 0.541016)",
      fill: "#DBDBDB"
    })
  ])
], -1))
const _hoisted_9 = { class: "value" }

import { ref, watch } from "vue";
import { ISwitchTabs } from "@/interfaces/assessments/ISwitchTabs";
import BarChartIcon from "@/components/svgs/barChartIcon.vue";
import { getComponentUiText } from "@/utils/utilities";
// eslint-disable-next-line no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'tableActionSwitchTab',
  props: {
  tabs: {
    type: Array as () => ISwitchTabs[],
    required: true,
  },
  defaultTab: {
    type: Number,
    default: 0,
    required: false,
  },
  idSelectedTab: {
    type: String,
    default: null,
    required: false,
  },
  score: {
    type: Number,
    default: 1,
    required: false,
  },
  risk: {
    type: Number,
    default: 1,
    required: false,
  },
  itemClass: {
    type: String,
    default: "",
    required: false,
  },
},
  emits: ["update:tab"],
  setup(__props, { emit }) {

const props = __props;




const selectedTab = ref(props.defaultTab);

watch(
  () => props.idSelectedTab,
  (value) => {
    props.tabs.forEach((tab, index) => {
      if (tab.id === value) {
        selectedTab.value = index;
      }
    });
  },
);

const selectTab = (tab: ISwitchTabs, index) => {
  emit("update:tab", tab.id);
  selectedTab.value = index;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass([
            {
              selectedTab: selectedTab.value === index,
              unselectedTab: selectedTab.value !== index,
            },
            `tab tw-px-[20px] tw-pt-[20px] tw-pb-[17px] tw-cursor-pointer tw-text-center ${__props.itemClass}`,
          ]),
            onClick: ($event: any) => (selectTab(tab, index))
          }, [
            _createElementVNode("span", null, _toDisplayString(tab.title), 1)
          ], 10, _hoisted_4))
        }), 128))
      ]),
      _renderSlot(_ctx.$slots, "rightHeader", {}, () => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(BarChartIcon),
          _createElementVNode("div", _hoisted_6, [
            _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
                "app-assess-recommendations-action-table-label-score-1",
              )) + " ", 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(__props.score), 1),
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(_unref(getComponentUiText)(
                "app-assess-recommendations-action-table-label-risk-1",
              )) + " ", 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(__props.risk), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})